import ApiService from "../services/ApiService";

const state = {
  config: undefined,
  version: null,
  requestInProgressCount: 0
};

const actions = {
  async fetchVersion({ commit }) {
    try {
      const { data } = await ApiService.getVersion();
      commit("setVersion", data.version);
    } catch (e) {
      /** NO-OP **/
    }
  },

  async getConfig({ commit }) {
    const { data: config } = await ApiService.getConfig();
    commit("setConfig", config);
  }
};

const mutations = {
  setVersion(state, payload) {
    state.version = payload;
  },
  setConfig(state, config) {
    state.config = config;
  },
  incrementRequestInProgress(state) {
    state.requestInProgressCount++;
  },
  decrementRequestInProgress(state) {
    state.requestInProgressCount--;
  }
};

const getters = {
  requestInProgress: state => {
    return state.requestInProgressCount > 0;
  }
};

export const app = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
